
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { cambiarEstadoUsuario } from "../../services";

import Swal from "sweetalert2";




const storeApi = (set) => ({

    activeUsuario: null,
    usuarioVenta: null,
    usuarios: [],
    clientes: [],
    operarios: [],
    isLoadingUsuario: false,
    total: 0,


    infoActiveUsuario: (info) => {
        set({ activeUsuario: info });
    },
    
    
    activarUserVenta: (info) => {
        set({ usuarioVenta: info });
    },


    clearListUser: () => {
        set({ usuarios: [] });
    },



    startCambiarEstadoUsuario: async(id) => {
        try {
            await cambiarEstadoUsuario(id);
            Swal.fire('Exitoso', 'Cambio de estado exitoso', 'success');
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },


});






export const useUsuariosStore = create()(
    devtools(
        persist(
            storeApi,
            { 
                name: 'venta-user',
                partialize: (state) => ({ usuarioVenta: state.usuarioVenta })
            }
        )
    )
);
